// Alias
import DefaultHeader from '../../header';

export default DefaultHeader;
